const cards = [
  {
    title: '某顶流深夜发文：到底发生了什么？',
    desc: '近日某顶流深夜发布长文引发全网猜测，各方解读层出不穷，本站在线吃瓜为你梳理事件全貌。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20social%20media%20breaking%20news%20concept%20with%20dramatic%20lighting%20and%20text%20message%20visualization%2C%20warm%20coral%20and%20amber%20gradients%2C%20modern%20editorial%20design%2C%20mysterious%20atmosphere%2C%20soft%20glow%20effects%2C%20clean%20composition&width=800&height=560&seq=card-01&orientation=landscape',
    tag: '娱乐圈',
    time: '2小时前',
  },
  {
    title: '综艺录制现场突发：嘉宾反应耐人寻味',
    desc: '某热门综艺录制过程中发生意外状况，多位嘉宾现场反应引发网友热议，更多细节持续跟进。',
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20dramatic%20moment%20abstract%20concept%20with%20stage%20lights%20and%20silhouettes%2C%20warm%20amber%20spotlights%2C%20entertainment%20show%20atmosphere%2C%20editorial%20photography%20style%2C%20soft%20gradients&width=800&height=560&seq=card-02&orientation=landscape',
    tag: '综艺',
    time: '5小时前',
  },
  {
    title: '代言人风波：品牌方和艺人方各执一词',
    desc: '某知名品牌与代言人之间的解约事件持续发酵，双方说法矛盾，吃瓜群众在线围观事件最新进展。',
    image: 'https://readdy.ai/api/search-image?query=Corporate%20brand%20and%20celebrity%20endorsement%20conflict%20abstract%20visual%2C%20split%20composition%20with%20warm%20and%20cool%20contrast%2C%20coral%20and%20neutral%20tones%2C%20business%20news%20concept%2C%20editorial%20style%2C%20dramatic%20lighting&width=800&height=560&seq=card-03&orientation=landscape',
    tag: '品牌代言',
    time: '8小时前',
  },
  {
    title: '新剧路透：主角造型引发书粉热议',
    desc: '热门IP改编剧现场路透照曝光，主演造型与原著描述差距引发讨论，剧组尚未正式回应。',
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20scenes%20abstract%20concept%20with%20costume%20and%20lighting%20elements%2C%20warm%20dramatic%20atmosphere%2C%20cinematic%20lighting%20in%20amber%20tones%2C%20editorial%20photography%2C%20mysterious%20mood&width=800&height=560&seq=card-04&orientation=landscape',
    tag: '影视爆料',
    time: '12小时前',
  },
  {
    title: '机场偶遇：当红艺人的日常引关注',
    desc: '多位当红艺人近期机场私服造型被拍到，网友围绕穿搭品味展开激烈讨论，时尚圈也加入评析。',
    image: 'https://readdy.ai/api/search-image?query=Fashion%20and%20style%20discussion%20abstract%20collage%20with%20clothing%20silhouettes%20and%20trend%20indicators%2C%20warm%20neutral%20tones%20with%20coral%20accents%2C%20editorial%20fashion%20magazine%20layout%2C%20minimal%20composition&width=800&height=560&seq=card-05&orientation=landscape',
    tag: '时尚八卦',
    time: '1天前',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-xs font-label text-primary-600 bg-primary-50 px-3 py-1 rounded-full">深度吃瓜</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-3">
            图文深度解读
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-[560px] mx-auto">
            精选热门吃瓜话题，带你了解更多细节与背景
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 3).map((card, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded text-[10px] font-label bg-primary-500/85 text-background-50 whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-foreground-400">{card.time}</span>
                </div>
                <h3 className="text-sm font-label font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {cards.slice(3, 5).map((card, idx) => (
            <div
              key={idx + 3}
              className="group flex flex-col sm:flex-row rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full sm:w-[200px] aspect-[4/3] sm:aspect-auto overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex-1 flex flex-col justify-center">
                <span className="px-2 py-0.5 rounded text-[10px] font-label bg-accent-100 text-accent-700 whitespace-nowrap inline-block w-fit mb-2">
                  {card.tag}
                </span>
                <h3 className="text-sm font-label font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                  {card.desc}
                </p>
                <span className="text-xs text-foreground-400 mt-3">{card.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}